import { css } from 'styled-components';

import { paginationTokens } from '../../tokens/components/Pagination/tokens';
import { buttonTokens } from '../../tokens/components/Button/tokens';

export const paginationCore = css`
  align-items: baseline;
  display: flex;
  justify-content: center;
  margin: ${paginationTokens.CoreMargin};

  &:hover {
    text-decoration: none;
  }

  ${({ theme }) =>
    theme.disabled &&
    css`
      cursor: default;
      opacity: 50%;
      pointer-events: none;
    `};
`;

export const paginationItem = css`
  background-color: ${paginationTokens.ItemBackgroundColorInitial};
  border: 0;
  border-radius: ${paginationTokens.ItemBorderRadius};
  color: ${paginationTokens.ItemColorInitial};
  cursor: pointer;
  display: inline-block;
  font-size: ${paginationTokens.ItemFontSize};
  font-weight: ${paginationTokens.ItemFontWeight};
  line-height: ${paginationTokens.ItemFontLeading};
  margin: ${paginationTokens.ItemMargin};
  padding: 0;
  text-align: center;
  transition-duration: 80ms;
  transition-property: background-color, box-shadow, color, outline;
  transition-timing-function: ease-out;
  vertical-align: baseline;
  white-space: nowrap;
  width: ${paginationTokens.ItemWidth};

  &:focus-visible {
    outline: ${buttonTokens.BorderWidthBaseDefault} ${buttonTokens.BorderStyleBaseDefault}
      ${buttonTokens.BorderColorBaseKeyboardFocus};
    box-shadow: 0 0 0 ${buttonTokens.ShadowWidthBaseKeyboardFocus} ${buttonTokens.ShadowColorBaseKeyboardFocus};
  }

  &:hover {
    background-color: ${paginationTokens.ItemBackgroundColorHover};
    color: ${paginationTokens.ItemColorHover};
  }
`;

export const paginationItemActive = css`
  background-color: ${paginationTokens.ItemBackgroundColorActive};
  border-color: ${paginationTokens.ItemBorderColorActive};
  color: ${paginationTokens.ItemColorActive};
  pointer-events: none;
`;

export const paginationSpacer = css`
  align-self: flex-start;
  line-height: ${paginationTokens.SpacerLeading};
  pointer-events: none;
  width: ${paginationTokens.SpacerWidth};
`;

export const paginationTrim = css`
  margin: 0;
`;
